import { GridInitialState } from '@mui/x-data-grid';

export const ACCORDION_SUMMARY_STYLE = {
  paddingLeft: '26px',
  '&.MuiAccordionSummary-root': {
    height: '64px',
    minHeight: '64px',
  },
};

const DEFAULT_TABLE_SORT: GridInitialState['sorting'] = {
  sortModel: [{ field: 'createdAt', sort: 'desc' }],
};

/** Default for Caller assignments and Coordinator assignments on My Lists. */
export const DEFAULT_TABLE_FILTER: GridInitialState = {
  filter: {
    filterModel: {
      items: [
        {
          field: 'status',
          operator: 'isAnyOf',
          value: ['In progress', 'Not started'],
        },
      ],
    },
  },
  sorting: DEFAULT_TABLE_SORT,
};

/** All Lists tab — sort only, no default Status filter. */
export const ALL_LISTS_TABLE_INITIAL_STATE: GridInitialState = {
  sorting: DEFAULT_TABLE_SORT,
};
